module.exports = __webpack_public_path__ + "img/visu-fauche@2x.b2e1e3c0.jpg";